import { sendMQTTMessage, parseMqttResult } from '../helper'
import { IMQTTRes } from '../type'
import {IAlbumItem, IAlbumListItem} from '@remote/type/album'

type TGetAlbumFileListParams = {
  platform: string // 'pc'|'an'|'ios' "访问来源" 
  sub_path: string // 文件目录，为空则获取所有相册照片
  media: number // 类型：0全部；1视频；2图片
  page_size: number
  page_token: string // 首页为空，次页取上次list的“page_token” 
}

type TGetAlbumFileListRes = {
  ret: number
  total: number
  page_token: string
  sub_path: string
  result: IAlbumItem[]
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const fakerData = {
  'ret': 0,
  'total': 500,
  'page_token': '2',
  'sub_path': '',
  'result': [
    {
      'key': '',
      'name': '1646189056393.jpg',
      'size': 4821635,
      'cid': '',
      'time_create': '1700466515',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/相册备份/1426433137/RMX3350/myImage/1646189056393.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 3456,
      'height': 4608,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/7E56635BB4F3B048A8AAAD5E9CD5048396EE6E01.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'd137615314807be8b01feb7e686c2da2',
    },
    {
      'key': '',
      'name': '1653015382295.jpg',
      'size': 3640729,
      'cid': '',
      'time_create': '1700466511',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/相册备份/1426433137/RMX3350/myImage/1653015382295.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 3456,
      'height': 4608,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/B0AE9B7A26BE70D998297066AEBE49F736B9127F.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '7e7a92cd9e41fe91b106b6d356c13562',
    },
    {
      'key': '',
      'name': '1653015432929.jpg',
      'size': 4048343,
      'cid': '',
      'time_create': '1700466506',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/相册备份/1426433137/RMX3350/myImage/1653015432929.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 3456,
      'height': 4608,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/FA71631DC9FCCB30094F682C1251C8E67DC5678D.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '2f57814755e60ffbeef83b5bc503841e',
    },
    {
      'key': '',
      'name': '1658211322655.jpg',
      'size': 4240987,
      'cid': '',
      'time_create': '1700466502',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/相册备份/1426433137/RMX3350/myImage/1658211322655.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 3456,
      'height': 4608,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/53ACE782528A6336808F2A2A4EE8CEAD7F7F3C26.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '80f8cf59e540a2e193de4b46c5dea5f7',
    },
    {
      'key': '',
      'name': '1658474621010.jpg',
      'size': 3727754,
      'cid': '',
      'time_create': '1700466498',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/相册备份/1426433137/RMX3350/myImage/1658474621010.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 3456,
      'height': 4608,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/32C376B5E663BC5BE0084708482BFE634409EB1C.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '861d09e72f1b812c6de2983499ce3ebb',
    },
    {
      'key': '',
      'name': 'StockSnap_BTYUNHPXLW.jpg',
      'size': 12346302,
      'cid': '',
      'time_create': '1697522783',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_BTYUNHPXLW.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 5184,
      'height': 3456,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/D739F799AE63BF96EBDC192A92BC7489FD217404.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '0c620d4b5a0d8c47817dbebc67fb381b',
    },
    {
      'key': '',
      'name': 'StockSnap_Z8S6TQVU80.jpg',
      'size': 10789314,
      'cid': '',
      'time_create': '1697513456',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_Z8S6TQVU80.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 4016,
      'height': 6016,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/7988E7F0122F7BD6E601E7ECD12488A4DA4E3925.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'c66c76ed4e97fc8861ded79c63883ed2',
    },
    {
      'key': '',
      'name': 'StockSnap_NNG2GGUGLU.jpg',
      'size': 7696170,
      'cid': '',
      'time_create': '1697513212',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_NNG2GGUGLU.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 6016,
      'height': 4016,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/3EE9235E5D9F527A953C29C078AD7CA3CB20F528.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'bcd3b6e8c90bea44e2f26bcb6d86c230',
    },
    {
      'key': '',
      'name': 'StockSnap_OQ7ZZXSTN7.jpg',
      'size': 11059694,
      'cid': '',
      'time_create': '1697513087',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_OQ7ZZXSTN7.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 6016,
      'height': 4016,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/CDB886C76C8E0F60986E9E76ABA009C35CEAC21D.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '71688a1cf4292302023e7e274cefdbc4',
    },
    {
      'key': '',
      'name': 'StockSnap_UKQ1BAXEYR.jpg',
      'size': 22625342,
      'cid': '',
      'time_create': '1697512852',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_UKQ1BAXEYR.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 7825,
      'height': 5219,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/5C2291834F9622B8845F90291EC2D516F529E988.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '0fe494eb242f7c81d9b7d4f7bd9c9f6f',
    },
    {
      'key': '',
      'name': 'StockSnap_OXRKQCTTCK.jpg',
      'size': 9957400,
      'cid': '',
      'time_create': '1697512745',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_OXRKQCTTCK.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 5760,
      'height': 3840,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/020789DBC179FF8D65A6D10F03EA9FEE08F88C51.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'ce15e4a03c1edfdb341456bf96a488a1',
    },
    {
      'key': '',
      'name': 'StockSnap_80QIX6YO2W.jpg',
      'size': 5414524,
      'cid': '',
      'time_create': '1697512687',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_80QIX6YO2W.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 5472,
      'height': 3078,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/5BA8184B23EE192E89D144DAC4CC0CA75CDE7F69.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'ef8afaa189f447132dc801c6c40e7762',
    },
    {
      'key': '',
      'name': 'StockSnap_4RUHVKXOYI.jpg',
      'size': 6331741,
      'cid': '',
      'time_create': '1697512483',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_4RUHVKXOYI.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 4887,
      'height': 2749,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/43322E73BBABE8AA61E78F845A392DA72D8E86F9.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'c99110e2df4b1c037427b147f0fe97e4',
    },
    {
      'key': '',
      'name': 'StockSnap_XPHM4NIDSJ.jpg',
      'size': 10286637,
      'cid': '',
      'time_create': '1697512097',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_XPHM4NIDSJ.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 5760,
      'height': 3840,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/8D40CDD015A57844B4468C34E69FD52CC1BC873F.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '50f0f9a61a1378f0c7fe2d6d83fe091e',
    },
    {
      'key': '',
      'name': 'StockSnap_D5VVUIQNDL.jpg',
      'size': 10479726,
      'cid': '',
      'time_create': '1697511956',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/大图/StockSnap_D5VVUIQNDL.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 4319,
      'height': 6479,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/0095257D4956E54A3BD7A83BC0C7B15A1582027A.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'd82b94518eb397e8123c00573dde18e0',
    },
    {
      'key': '',
      'name': 'pic_478.jpg',
      'size': 185312,
      'cid': '',
      'time_create': '1697511673',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/pic_478.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 420,
      'height': 280,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/65BA42D4011F3805D65336EE1D5B9DF9753625E1.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '202758d0b97bc0ab0f429dfc64bcea48',
    },
    {
      'key': '',
      'name': 'pic_479.jpg',
      'size': 175952,
      'cid': '',
      'time_create': '1697511673',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/pic_479.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 420,
      'height': 280,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/C69E1C7AE0D35BCF7FC1B5A3A252EF4049ED91A0.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '3c1efa942e7e444de5a0c2df78caf4ea',
    },
    {
      'key': '',
      'name': 'pic_480.jpg',
      'size': 151144,
      'cid': '',
      'time_create': '1697511673',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/pic_480.jpg',
      'sub_path': '',
      'status': 0,
      'media': 2,
      'duration': 0,
      'orientation': 0,
      'width': 420,
      'height': 280,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/1B5327CB79023809B6A635D59ACFF18C05DED902.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': '6e91f870048fc070efd015507ba99b46',
    },
    {
      'key': '',
      'name': 'pic_481.jpg',
      'size': 140698,
      'cid': '',
      'time_create': '1697511673',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/pic_481.jpg',
      'sub_path': '',
      'status': 0,
      'media': 1,
      'duration': 232010,
      'orientation': 0,
      'width': 420,
      'height': 280,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/C227320CD681082CC9951FA8E9A843FEE4ED37E9.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'dfbb0eea69f2c59b9cffcba033e74940',
    },
    {
      'key': '',
      'name': 'pic_482.png',
      'size': 23201,
      'cid': '',
      'time_create': '1697511673',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '/xos_storage/v1/4e742386-b059-47f7-ba2f-31a436459749/1142 Free CC0 Autumn Stock Photos - StockSnap.io/1142 Free CC0 Autumn Stock Photos - StockSnap.io/pic_482.png',
      'sub_path': '',
      'status': 0,
      'media': 1,
      'duration': 232010,
      'orientation': 0,
      'width': 160,
      'height': 160,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/3A2BD578591C6BC4E39128BB09B0AD8B36B394D9.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'fe7d89ae8c0a836e5806537292315c42',
    },
    {
      'key': '',
      'name': '20230822174421.mp4',
      'size': 645412,
      'cid': '',
      'time_create': '1701077182',
      'model': '',
      'uuid': '',
      'm_path': '',
      'backup_path': '',
      'rel_path': '20230822174421.mp4',
      'sub_path': '',
      'status': 0,
      'media': 1,
      'duration': 15,
      'orientation': 0,
      'width': 800,
      'height': 0,
      'cover': 'https://oss.shumeipan.com/hezi/resource/thumb/9679538074991201EEA3747A2B9F802B4874441B.jpg',
      'userid': '',
      'gcid': '',
      'label': '',
      'ext_data': '',
      'md5sum': 'd7be07ee5ca944b601f81d46c04967ea',
    },
  ],
} as TGetAlbumFileListRes

export function getAlbumFileList (params: TGetAlbumFileListParams): Promise<TGetAlbumFileListRes> {
  return sendMQTTMessage<IMQTTRes<TGetAlbumFileListRes>>('xl_shell', 'get_album_file_list', params).then(data => {
    const { result } = parseMqttResult<TGetAlbumFileListRes>(data)
    console.log('getAlbumFileList', params, result)
    return result
    // return fakerData
  })
}

type TGetAlbumListRes = {
  ret: number
  total: number
  page_token: string
  sub_path: string
  result: IAlbumListItem[]
}

export function getAlbumList (params: Omit<TGetAlbumFileListParams, 'sub_path'|'media'>): Promise<TGetAlbumListRes> {
  return sendMQTTMessage<IMQTTRes<TGetAlbumListRes>>('xl_shell', 'get_album_list', params).then(data => {
    const { result } = parseMqttResult<TGetAlbumListRes>(data)
    console.log('getAlbumList', params, result)
    return result
    // return result.result?.length ? result : fakerData
  })
}

export type TDeleteAlbumFileParams = {
  platform: string
  paths: Array<{path: string; media: number}>
  keys: Array<{path: string; key: string}>
}

export function deleteAlbumFile (params: TDeleteAlbumFileParams) {
  return sendMQTTMessage<IMQTTRes>('xl_shell', 'del_album_file', params).then(data => {
    const { result } = parseMqttResult(data)
    console.log('deleteAlbumFile', params, result)
    return result
  })
}